export default "__VITE_ASSET__B2mRKs$E__"